import React from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { Input, AutoCompleteSelect } from '../../form'
import { FormTemplateField } from '../../others/'
import RPASubmitHistory from '../../../../containers/authorised/addOns/rpa/vision_insurance/eligibilityVerify/RPASubmitHistory';
import RPAInsuranceVerify from '../../../../containers/authorised/addOns/rpa/vision_insurance/eligibilityVerify/RPAInsuranceVerify';

function resetPlanValues(props) {
  props.dispatch(change(props.formName, `${props.basePatientName}[plan_name]`, null))
  props.dispatch(change(props.formName, `${props.basePatientName}[insurance_plan_id]`, null))
}

// let resetInsuranceData = {}

const Insurance = (props) => {
  const { insuranceType, isTemplate, baseTemplateName, basePatientName, baseFieldValues, insurancePlans, selectedInsuranceId, selectedInsurance, visionInsuranceConfig, patientFormValues, patient, formName } = props

  const handleOnInsuranceChange = (data) => {
    props.dispatch(change(formName, `${basePatientName}.insurance_name`, data.name))
    props.dispatch(change(formName, `${basePatientName}[_destroy]`, false));
    props.dispatch(change(formName, `${basePatientName}.id`, '')) // don't submit id on change
    // patient_insurance_attributes = values getting removed
    // patientFormValues[props.basePatientName]?.id && props.dispatch(change(formName, `patient_insurance_attributes`, getResetInsuranceIds(props.basePatientName)))
  }

  const handleResetInsurance = () => {
    props.dispatch(change(formName, `${basePatientName}[settings_insurance_id]`, null));
    props.dispatch(change(formName, `${basePatientName}[insurance_name]`, null));
    props.dispatch(change(formName, `${basePatientName}[_destroy]`, true));
    // props.dispatch(change(formName, `patient_insurance_attributes`, getResetInsuranceIds()))
    return true;
  }

  // const getResetInsuranceIds = (changedFieldName) => {
  //   resetInsuranceData = {
  //     ...resetInsuranceData,
  //     [changedFieldName || props.basePatientName]: !changedFieldName ? null :
  //       {
  //         id: !changedFieldName ? null : patientFormValues[props.basePatientName]?.id,
  //         settings_insurance_id: selectedInsurance.id,
  //         insurance_name: selectedInsurance.name,
  //         store_id: localStorage.getItem('StoreID')
  //       }
  //   };
  //   return resetInsuranceData;
  // }

  return (
    <>
      <FormTemplateField
        isTemplate={isTemplate}
        isOpen={true}
        name={`${basePatientName}[settings_insurance_id]`}
        baseName={`${baseTemplateName}[insurance]`}
        displayName={`${basePatientName}[insurance_name]`}
        fieldValues={baseFieldValues.insurance}
        component={AutoCompleteSelect}
        onResetVal={() => handleResetInsurance()}
        onChange={(e) => resetPlanValues(props, e)}
        onChangeHook={data => handleOnInsuranceChange(data)}
        valueField="id"
        textField="name"
        klass="Settings::Insurance"
        filter={{ insurance_type: insuranceType }}
        wrapperClasses="col-4 form-group"
      />
      <FormTemplateField
        key={`${insurancePlans && insurancePlans.length}-${selectedInsuranceId}`}
        isTemplate={isTemplate}
        isOpen={true}
        name={`${basePatientName}[settings_insurance_plan_id]`}
        baseName={`${baseTemplateName}[plan]`}
        displayName={`${basePatientName}[insurance_plan_name]`}
        fieldValues={baseFieldValues.plan}
        component={AutoCompleteSelect}
        data={insurancePlans}
        valueField="id"
        textField="name"
        wrapperClasses="col-3 form-group"
      />
      <FormTemplateField
        isTemplate={isTemplate}
        isOpen={true}
        name={`${basePatientName}[member_id]`}
        baseName={`${baseTemplateName}[member_id]`}
        fieldValues={{ ...baseFieldValues.member_id, required: (selectedInsuranceId && selectedInsurance?.require_member_id) }}
        component={Input}
        className="form-control"
        wrapperClasses="col-3 form-group"
      />
      {/* <div className='col-2 pl-0 align-self-center'>
        {
          baseFieldValues.insurance.visible && selectedInsuranceId &&
          <Field
            label="Remove?"
            component={Checkbox}
            wrapperClasses="label-icons form-group mb-0"
            name={`${basePatientName}[is_archived]`}
          />
        }
      </div> */}
      {(!isTemplate && visionInsuranceConfig?.visible && patient.id) && <>
        <div className='col-2 pl-0 align-self-center'>
          <RPAInsuranceVerify
            selectedInsuranceName={patientFormValues?.[basePatientName]?.insurance_name}
            selectedInsuranceMemberId={patientFormValues?.[basePatientName]?.member_id}
            insuranceType={basePatientName}
            selectedInsurance={selectedInsurance}
            isPatientView={true}
          />
        </div>
        <div className='col-10'>
          <RPASubmitHistory insuranceType={basePatientName} wrapperClasses="mb-4" />
        </div>
      </>
      }
    </>
  )
}

const mapStateToProps = (state) => {
  const { organisation: { organisation }, form: { patientForm }, patient } = state
  return {
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance,
    patientFormValues: patientForm?.values,
    // order: order?.order,
    patient: patient?.patient,
  }
}

export default connect(mapStateToProps)(Insurance);
